module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAYFBMVEUAAABqdItrdIppcohoa4pqc4pqc4pjcoFqdIpqc4pgYIBrc4pqc4prdIlrdIlrdIpqdIpqc4podIhpcopocodrc4lAQIBrc4pqdIppcohqaoBqdIprc4pqcodqdIlqc4lqyfD1AAAAIHRSTlMAf8EtGJmuEdFwCNefkXnmo4g9NSYhBPHrWwy3s2BsVGq0SZoAAAC8SURBVBjTfU9JEoMwDEucfWNNAhRo///LOqTpgQM+aGRZHo3I4zAAdpMUXc+zp6rtXAygF58KWzQMgqPYyW1ithosmzbZIaG0CikVrHsTlXPqJtrJG+Nn23YzIoAwORsBSMMbYZMIviMl0yPIDwJzCBlmQmbISN3VYeHlHhmL5Sf1V5wor/sBcOwlJ9TW/QvbMCT4otZIqlWQ/wzhR17ONG3UtlGuB3W1klBCmzes4zyFfqy+NpFqTTl5mC+wEgbn9Z+YUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/ZhiAnTong_1.png
// module id = Jb6t
// module chunks = 57